export const CONNECTION_ERROR = "Could not Connect try Again"

